export default {
  title: "Activities",
  subtitle: "All platform activities",
  searchPlaceholder: "Search by activity or owner name...",
  loadError: "Failed to load activities",
  retry: "Retry",
  empty: "No activities match your filters.",
  openRowAria: "Open activity {{name}}",
  filters: {
    status: "Status",
    statusAll: "All",
    statusActive: "Active",
    statusInactive: "Inactive",
    visibility: "Visibility",
    visibilityAll: "All",
    visibilityVisible: "Visible",
    visibilityHidden: "Hidden",
    discounts: "Discounts",
    discountsAll: "All",
    discountsActive: "Active discounts",
    category: "Category",
    categoryAll: "All",
    paymentModel: "Payment method",
    paymentModelAll: "All",
  },
  paymentModels: {
    upfront: "Upfront",
    deposit: "Deposit",
    receiptBased: "Receipt-based",
  },
  categories: {
    restaurant: "Restaurant",
    attraction: "Experience",
    genericService: "Service",
  },
  columns: {
    name: "Activity",
    category: "Category",
    owner: "Owner",
    paymentModel: "Payment method",
    commission: "Commission",
    visibility: "Visibility",
    discount: "Discount",
  },
  cells: {
    visible: "Visible",
    hidden: "Hidden",
    discountActive: "Active",
    discountNone: "—",
  },
} as const;
